import React from 'react';
import { Check, Trophy } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Metodo() {
  const beneficios = ['Técnica específica para zurda', '100% aplicable en cancha de fútbol 5', 'Diseñado para el zurdo amateur argentino', 'Acceso inmediato desde cualquier dispositivo', 'Sirve para todos los niveles amateur', 'Ejercicios desde 20 minutos por sesión'];
  return <>
      {/* PRESENTACIÓN PRODUCTO */}
      <section className="py-16 bg-row1 relative border-t border-white/5" data-id="element-153">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-154">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-155">
            <FadeIn data-id="element-156">
              <h3 className="font-display text-celeste font-bold tracking-widest uppercase mb-2" data-id="element-157">
                Presentamos
              </h3>
              <h2 className="font-display md:text-5xl font-black mb-6 uppercase text-white text-[32px]" data-id="element-158">
                ZURDO MASTER PACK — FÚTBOL 5
              </h2>
              <p className="text-gray-300 text-[16px]" data-id="element-159">
                El primer sistema completo diseñado exclusivamente para
                jugadores zurdos de fútbol 5 que quieren dominar la cancha con
                su pierna izquierda.
              </p>
            </FadeIn>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-160">
            {beneficios.map((ben, idx) => <FadeIn key={idx} delay={idx * 0.1} direction="up" data-id="element-161">
                <div className="bg-navy border border-white/5 p-6 rounded-xl flex items-center gap-4 hover:border-celeste/50 transition-colors" data-id="element-162">
                  <div className="bg-celeste/10 p-2 rounded-full text-celeste flex-shrink-0" data-id="element-163">
                    <Check className="w-6 h-6" data-id="element-164" />
                  </div>
                  <h3 className="font-bold text-gray-200 leading-snug" data-id="element-165">
                    {ben}
                  </h3>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* MÉTRICAS */}
      <section className="py-12 bg-celeste border-y-4 border-gold relative" data-id="element-166">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-167">
          <FadeIn data-id="element-168">
            <div className="flex justify-center mb-8" data-id="element-169">
              <span className="inline-flex items-center gap-2 bg-navy text-white font-display font-bold text-sm md:text-base uppercase tracking-widest px-6 py-2 rounded-full shadow-lg border border-gold/30" data-id="element-170">
                <Trophy className="w-5 h-5 text-gold" data-id="element-171" /> Sistema N°1 para zurdos
                en Argentina
              </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 divide-x-0 md:divide-x divide-navy/20" data-id="element-172">
              {[{
              val: '+120',
              label: 'EJERCICIOS'
            }, {
              val: '6',
              label: 'TOMOS'
            }, {
              val: '30',
              label: 'DÍAS'
            }, {
              val: '6',
              label: 'BONOS'
            }].map((stat, idx) => <div key={idx} className="text-center px-4" data-id="element-173">
                  <div className="font-display font-black text-4xl md:text-5xl text-navy mb-1" data-id="element-174">
                    {stat.val}
                  </div>
                  <div className="font-bold text-navy/80 text-sm tracking-widest uppercase" data-id="element-175">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>
    </>;
}